module.exports = __webpack_public_path__ + "static/img/WechatIMG31.dfa32e58.png";